import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetPreferencesResponse } from './types/get-preferences.type';
import { GetPreferencesPartialRequest } from './types/get-preferences-partial.type';
import { getPreferencesSchema } from './schemas/get-preferences.schema';

export const getPreferencesPartial = async ({
	id,
	token,
}: GetPreferencesPartialRequest): Promise<
	AxiosResponse<GetPreferencesResponse>
> => {
	const apiUrl = `/account/subscriptions/partial?id=${id}&token=${token}`;

	const response = api.get(apiUrl);

	return response;
};
